/**
 * Tiny helper — pulls the current Supabase access token and returns it as a
 * `Authorization: Bearer …` header object for the crm-proxy function.
 *
 * Kept separate from adapter.ts so the adapters can be tested without dragging in
 * Supabase. If the user isn't signed in (or session has rotated), returns {} —
 * the proxy will then 401 and the adapter surfaces NOT_AUTHENTICATED.
 */

import { getSupabase } from '../supabase';

export async function getProxyAuthHeader(): Promise<Record<string, string>> {
  try {
    const supabase = getSupabase();
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return token ? { authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
